import type { TableView } from "owa-mail-list-store";
import { mutatorAction } from "satcheljs";

const setTableIsInCheckedModeMutator: (tableView: TableView, isInCheckedMode: boolean) => void = mutatorAction("setTableIsInCheckedMode", function setTableIsInCheckedMode(tableView: TableView, isInCheckedMode: boolean): void {
    tableView.isInCheckedMode = isInCheckedMode;
});
export default setTableIsInCheckedModeMutator;
